import React from 'react';

import {Cell} from 'fixed-data-table-2';
import PropTypes from 'prop-types';

import {ColumnHeader} from './column-header';

EntityTableHeader.propTypes = {
    fieldName: PropTypes.string.isRequired,
    entityType: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
    onPopoverOpen: PropTypes.func.isRequired,
    onPopoverClose: PropTypes.func.isRequired,
    schema: PropTypes.object.isRequired,
    filters: PropTypes.shape({
        addFilters: PropTypes.func,
        updateFilter: PropTypes.func,
        removeFilters: PropTypes.func,
        selected: PropTypes.array.isRequired,
    }),
    fields: PropTypes.shape({
        selected: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        reorderFields: PropTypes.func.isRequired,
    }).isRequired,
    sort: PropTypes.shape({
        field: PropTypes.string,
        direction: PropTypes.string,
    }).isRequired,
    onToggleSort: PropTypes.func.isRequired,
    isAllSelected: PropTypes.bool.isRequired,
    selectAllItems: PropTypes.func,
    widthAdjustment: PropTypes.number,
};

export function EntityTableHeader(props) {
    const {
        entityType,
        fieldName,
        schema,
        isAllSelected,
        selectAllItems,
        filters,
        fields,
        sort,
        width,
        height,
        onPopoverOpen,
        onPopoverClose,
        onToggleSort,
        widthAdjustment,
    } = props;

    const schemaField = schema[fieldName];
    const filter = filters && filters.selected.find((entry) => Object.keys(entry)[0] === fieldName);
    const isDuplicatesMode =
        filters && filters.selected.find((entry) => entry.duplicates === true) !== undefined;

    const className = fieldName === 'name' ? 'ui-fixed-column-header' : undefined;

    return (
        <Cell className={className} width={width + widthAdjustment} height={height}>
            <ColumnHeader
                name={fieldName}
                index={fields.selected.findIndex((field) => field === fieldName)}
                entityType={entityType}
                field={schemaField}
                filter={filter}
                width={width}
                onSubmit={filters && filters.addFilters}
                onUpdate={filters && filters.updateFilter}
                onRemove={filters && filters.removeFilters}
                onPopoverOpen={onPopoverOpen}
                onPopoverClose={onPopoverClose}
                columnWasMoved={fields.reorderFields}
                isSorted={sort.field === fieldName}
                isDuplicatesMode={isDuplicatesMode}
                sortDirection={sort.direction}
                onSort={onToggleSort}
                onSelectAll={fieldName === 'name' ? selectAllItems : undefined}
                allSelected={isAllSelected}
            />
        </Cell>
    );
}
